import { instance } from 'api/internaltools';

export const getSettlementReports = async (searchParam) => {
  return instance.get(`/settlement-files?file_name_filter=${searchParam}`);
};

export const processSettlementFile = async (filePath) => {
  return instance.get(`/settlement-file?file_path=${filePath}`);
};
